import { showToast } from '@lokalise/louis';

import getEditorLink from '../../../../utils/location';
import ActivityDoneDescription, { Link } from '../../components/ActivityDoneDescription';

interface AllKeysSkippedDescriptionProps {
    message: string;
}

interface PageDescriptionProps {
    additionalMessage: string;
    projectId: string;
    branchName?: string;
}

export const AllKeysSkippedDescription = ({ message }: AllKeysSkippedDescriptionProps) => (
    <ActivityDoneDescription>{message}</ActivityDoneDescription>
);

export const EditorPageDescription = ({ additionalMessage, projectId, branchName }: PageDescriptionProps) => (
    <ActivityDoneDescription>
        {additionalMessage}
        {projectId ? <Link href={getEditorLink(projectId, branchName)}>Reload editor</Link> : 'Reload editor'} to see
        the changes
    </ActivityDoneDescription>
);

export const OtherPageDescription = ({ additionalMessage, projectId, branchName }: PageDescriptionProps) => (
    <ActivityDoneDescription>
        {additionalMessage}
        {projectId ? (
            <Link href={getEditorLink(projectId, branchName)}>Open the project’s editor</Link>
        ) : (
            'Open the project’s editor'
        )}{' '}
        to see the changes
    </ActivityDoneDescription>
);

const defaultFinishedAction = (
    isOnEditorPage: boolean,
    title: string,
    projectId: string,
    branchName?: string,
    additionalMessage = '',
    isAllKeysSkipped = false,
) => {
    const getDescription = () => {
        if (isAllKeysSkipped) {
            return <AllKeysSkippedDescription message={additionalMessage} />;
        }

        return isOnEditorPage ? (
            <EditorPageDescription
                additionalMessage={additionalMessage}
                branchName={branchName}
                projectId={projectId}
            />
        ) : (
            <OtherPageDescription additionalMessage={additionalMessage} branchName={branchName} projectId={projectId} />
        );
    };

    showToast({
        type: 'warning',
        title,
        autoClose: false,
        description: getDescription(),
    });
};

export default defaultFinishedAction;
